import { clientDashboard } from "@/utils/constants";
import { handleResponse, handleError } from "@/utils/functions";

export default (axios) => ({
  getClientDashboardFleetUtilizationStatistics(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(clientDashboard.fleetUtilizationStatistics, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getClientDashboardOrderStatistics(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(clientDashboard.orderStatistics, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getClientDashboardTripStatistics(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(clientDashboard.tripStatistics, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getClientDashboardFleetCapacityStatistics(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(clientDashboard.fleetCapacityUtilizationStatistics, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getClientDashboardSummary(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(clientDashboard.summaryStatistics, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getTripChartData(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(clientDashboard.tripChart, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getTurnAroundTimeChartData(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(clientDashboard.turnAroundTimeChart, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getOrderCreatedVsDeliveredChartData(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(clientDashboard.orderVsDeliveredChart, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getOrderReasonsChartData(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(clientDashboard.orderReasonsChart, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getOrderProcessingTimeChartData(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(clientDashboard.orderProcessingTimeChart, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getAssetUtilizationChartData(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(clientDashboard.assetUtilizationChart, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getFleetUtilizationChartData(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(clientDashboard.fleetUtilizationChart, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getAssetSummaryData(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(clientDashboard.assetSummary, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
});
